/* eslint-disable import/no-cycle */
import { FetchStatus } from '@flatsy/types/FetchStatus'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApplicationState, PublicApplicationData } from '@flatsy/types/Applications'
import {
  toFrontendApplicationBookingState,
  toFrontendApplicationState,
} from '@flatsy/utils/Conditions/Application'
import { FrontApplicationState } from '@flatsy/types/Applications/Status'
import {
  completeApplication,
  deleteApplication,
  getApplication,
  saveApplication,
  updateApplicationInterest,
} from './Action'
import { initialFormState } from './Constant'
import { ApplicantApplicationState } from './Type'

export const initialState: ApplicantApplicationState = {
  saveStatus: FetchStatus.IDLE,
  getStatus: FetchStatus.IDLE,
  application: initialFormState,
  justCompleted: false,
  postBookingInterestFromMail: false,
  isInterest: true,
}

export const applicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    saveLocalInformation(
      state: ApplicantApplicationState,
      action: PayloadAction<PublicApplicationData>
    ) {
      state.application = action.payload
      localStorage.setItem('tempApplication', JSON.stringify(action.payload))
    },
    setJustCompletedToFalse(state: ApplicantApplicationState) {
      state.justCompleted = false
    },
    setPostBookingInterestFromMailToTrue(state: ApplicantApplicationState) {
      state.postBookingInterestFromMail = true
    },
    setPostBookingInterestFromMailToFalse(state: ApplicantApplicationState) {
      state.postBookingInterestFromMail = false
    },
    setInterestToFalse(state: ApplicantApplicationState) {
      state.isInterest = false
    },
  },
  extraReducers: (builder) => {
    /* -------------------------------------------------------------------------- */
    /*                              SAVE APPLICATION                              */
    /* -------------------------------------------------------------------------- */
    builder.addCase(saveApplication.fulfilled, () => {
      // nothing
    })

    /* -------------------------------------------------------------------------- */
    /*                               GET APPLICATION                              */
    /* -------------------------------------------------------------------------- */
    builder.addCase(getApplication.pending, (state) => {
      state.getStatus = FetchStatus.LOADING
    })
    builder.addCase(getApplication.fulfilled, (state, action) => {
      state.application = {
        ...action.payload,
        computedState: toFrontendApplicationState(
          action.payload.state,
          action.payload.booking_state
        ),
        computedBookingState: toFrontendApplicationBookingState(action.payload),
      }

      state.getStatus = FetchStatus.SUCCEEDED
    })
    builder.addCase(getApplication.rejected, (state) => {
      state.getStatus = FetchStatus.FAILED
    })

    /* -------------------------------------------------------------------------- */
    /*                            COMPLETE APPLICATION                            */
    /* -------------------------------------------------------------------------- */
    builder.addCase(completeApplication.fulfilled, (state) => {
      state.justCompleted = true
    })
    builder.addCase(completeApplication.rejected, (state) => {
      state.justCompleted = true
    })
    builder.addCase(updateApplicationInterest.fulfilled, (state) => {
      state.application.interest = state.isInterest
    })

    /* -------------------------------------------------------------------------- */
    /*                              DELETE APPLICATION                            */
    /* -------------------------------------------------------------------------- */
    builder.addCase(deleteApplication.fulfilled, (state) => {
      state.application = {
        ...state.application,
        state: ApplicationState.ABANDONED,
        computedState: FrontApplicationState.FAILED,
      }
    })
  },
})
